const STATUS_CODE_MAP = {
  400: "badRequest",
  401: "authRequired",
  403: "accessDenied",
  404: "notFound",
  409: "upgrade_pending",
  422: "validationFailed",
  500: "serverUnexpected",
  502: "serverUnexpected",
  503: "serverUnexpected",
};

export async function readDealerPortalApiError(res, { defaultCode = "generic" } = {}) {
  const status = res.status;
  let body = {};

  try {
    const contentType = res.headers.get("content-type") || "";
    if (contentType.includes("application/json")) {
      body = await res.json();
    } else {
      const text = await res.text();
      body = { message: text.slice(0, 240) };
    }
  } catch {
    body = {};
  }

  const message = body.error || body.message || "";
  let code = body.code || null;

  if (!code) {
    code = STATUS_CODE_MAP[status] || (message ? null : defaultCode);
  }

  const error = new Error(message || defaultCode);
  error.code = code;
  error.status = status;
  return error;
}

export async function parseDealerPortalApiResponse(res, { defaultCode = "generic" } = {}) {
  if (res.ok) {
    return res.json();
  }
  throw await readDealerPortalApiError(res, { defaultCode });
}
